import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AdminSellerService } from '../../../_services/admin-seller.service';

@Component({
    selector: 'app-reject-seller-modal',
    templateUrl: './reject-seller-modal.component.html',
    styleUrls: ['./reject-seller-modal.component.css'],
    standalone: false
})
export class RejectSellerModalComponent implements OnInit {
    sellerId: string = '';
    rejectForm: FormGroup;
    submitted = false;

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private adminSellerService: AdminSellerService,
        private toastr: ToastrService
    ) {
        this.rejectForm = this.fb.group({
            reason: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(500)]]
        });
    }

    ngOnInit(): void {
        this.sellerId = this.route.snapshot.params['sellerId'];
        if (!this.sellerId) {
            this.router.navigate(['/admin', 'sellers']);
        }
    }

    get f() {
        return this.rejectForm.controls;
    }

    onSubmit(): void {
        this.submitted = true;

        if (this.rejectForm.invalid) {
            return;
        }

        const reason = this.rejectForm.value.reason;

        this.adminSellerService.rejectSeller(this.sellerId, reason).subscribe({
            next: () => {
                this.toastr.success('Seller rejected successfully');
                this.router.navigate(['/admin', 'sellers']);
            },
            error: () => {
                this.toastr.error('Error rejecting seller');
            }
        });
    }

    onCancel(): void {
        this.router.navigate(['/admin', 'sellers', this.sellerId]);
    }
}
